import React, { useState, useEffect } from 'react';
import { Modal } from '../common/Modal';
import { masterApi } from '../../api/masterApi';
import { formatDateTime } from '../../utils/formatDateTime';

export const NisugataHistoryViewer = ({ isOpen, onClose, productCode }) => {
  const [histories, setHistories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupedByBatch, setGroupedByBatch] = useState({});

  useEffect(() => {
    if (isOpen) {
      loadHistory();
    }
  }, [isOpen]);

  const loadHistory = async () => {
    try {
      setLoading(true);
      let data;
      if (productCode) {
        // 特定製品の履歴を取得
        data = await masterApi.getNisugataMasterHistory(
          productCode,
          undefined,
          undefined,
          undefined,
          200,
          0
        );
      } else {
        // 全履歴を取得
        data = await masterApi.getAllNisugataMasterHistory(
          undefined,
          undefined,
          undefined,
          500,
          0
        );
      }
      setHistories(data);

      // バッチIDでグループ化
      const grouped = {};
      data.forEach(h => {
        if (h.change_batch_id) {
          if (!grouped[h.change_batch_id]) {
            grouped[h.change_batch_id] = [];
          }
          grouped[h.change_batch_id].push(h);
        }
      });
      setGroupedByBatch(grouped);
    } catch (error) {
      console.error('履歴取得エラー:', error);
      alert('履歴の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="変更履歴一覧">
      <div className="space-y-4">

        {loading ? (
          <div className="text-center py-8 text-slate-600">読み込み中...</div>
        ) : histories.length === 0 ? (
          <div className="text-center py-8 text-slate-500">履歴がありません</div>
        ) : (
          <div className="space-y-4 max-h-[70vh] overflow-y-auto">
            {Object.entries(groupedByBatch).map(([batchId, batchHistories]) => (
              <div key={batchId} className="border border-slate-200 rounded-lg p-4">
                <div className="mb-2 text-sm text-slate-600">
                  <strong>製品コード:</strong> {batchHistories[0]?.product_code || '-'} | 
                  <strong> 製品名:</strong> {batchHistories[0]?.product_name || '-'} | 
                  <strong> 寸法:</strong> {batchHistories[0]?.size || '-'} | 
                  <strong> 変更日時:</strong> {formatDateTime(batchHistories[0]?.changed_at)} | 
                  <strong> 実行者:</strong> {batchHistories[0]?.changed_by || '-'} |
                  <strong> 理由:</strong> {batchHistories[0]?.change_reason || '-'}
                </div>
                <table className="w-full text-sm">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-slate-700 w-1/5">フィールド</th>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-slate-700 w-1/5">変更前</th>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-slate-700 w-1/5">変更後</th>
                      <th className="px-3 py-2 text-left text-xs font-semibold text-slate-700 w-2/5">変更理由</th>
                    </tr>
                  </thead>
                  <tbody>
                    {batchHistories.map((h, idx) => (
                      <tr key={idx} className="border-t border-slate-100">
                        <td className="px-3 py-2 break-words">{h.field_label || h.field_name}</td>
                        <td className="px-3 py-2 text-slate-600 break-words">{h.old_value || '-'}</td>
                        <td className="px-3 py-2 text-slate-900 font-medium break-words">{h.new_value || '-'}</td>
                        <td className="px-3 py-2 text-slate-700 break-words">{h.change_reason || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};
